import { createTimeIntervals } from '@pages/WorkSchedule/utils/createTimeIntervals';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import type { BaseOptionType } from 'antd/es/select';

// Способы формирования интервала времени
export const WS_DAYS = 'days';
export const WS_SHIFTS = 'shifts';
export const WS_WEEKS = 'weeks';

// Способы формирования интервала времени (по дням)
export const WS_ONE_DAY = 'oneDay';
export const WS_ONE_WEEK = 'oneWeek';
export const WS_TWO_WEEKS = 'twoWeeks';
export const WS_THREE_WEEKS = 'threeWeeks';
export const WS_FOUR_WEEKS = 'fourWeeks';
export const WS_FIVE_WEEKS = 'fiveWeeks';
export const WS_SIX_WEEKS = 'sixWeeks';
export const WS_SEVEN_WEEKS = 'sevenWeeks';
export const WS_EIGHT_WEEKS = 'eightWeeks';
export const WS_NINE_WEEKS = 'nineWeeks';
export const WS_TEN_WEEKS = 'tenWeeks';
export const WS_ELEVEN_WEEKS = 'elevenWeeks';
export const WS_TWELVE_WEEKS = 'twelveWeeks';

// Дни недели
export const WS_MONDAY = 'monday';
export const WS_TUESDAY = 'tuesday';
export const WS_WEDNESDAY = 'wednesday';
export const WS_THURSDAY = 'thursday';
export const WS_FRIDAY = 'friday';
export const WS_SATURDAY = 'saturday';
export const WS_SUNDAY = 'sunday';

// Месяцы
export const WS_JANUARY = 'january';
export const WS_FEBRUARY = 'february';
export const WS_MARCH = 'march';
export const WS_APRIL = 'april';
export const WS_MAY = 'may';
export const WS_JUNE = 'june';
export const WS_JULY = 'july';
export const WS_AUGUST = 'august';
export const WS_SEPTEMBER = 'september';
export const WS_OCTOBER = 'october';
export const WS_NOVEMBER = 'november';
export const WS_DECEMBER = 'december';

export const INITIAL_ADDITION_FILTERS: NWorkSchedule.Filters = {
  period: {
    primaryPeriod: WS_DAYS,
    detailedPeriod: WS_ONE_DAY,
  },
};
export const INITIAL_START_WORKING_TIME: BaseOptionType = {
  label: '10:00',
  value: createTimeIntervals()?.indexOf('10:00'),
};

export const INITIAL_END_WORKING_TIME: BaseOptionType = {
  label: '22:00',
  value: createTimeIntervals().indexOf('22:00'),
};
